<template>
  <div>
    <div class="settings-header"/>
    <aside
      v-click-outside="hideSettingsNav"
      :class="{opened: settingsNavOpened}"
      class="settings-nav scroll-area">
      <span
        class="settings-toggle-button"
        @click="toggleSettingsNav">
        <icon
          v-if="settingsNavOpened"
          name="chevron-left"/>
        <icon
          v-else
          name="bars"/>
      </span>
      <div>
        <router-link
          :to="backLink"
          tag="div"
          class="back-to-list">
          <icon
            name="angle-left"
            width="14"
            height="14"/> Back
        </router-link>
        <h2>Your Account</h2>
        <router-link
          :to="{ name: 'ProfileSettings' }"
          tag="span"
          active-class="settings-nav__list-item--active"
          class="settings-nav__list-item">Profile</router-link>
        <router-link
          :to="{ name: 'EmailSettings' }"
          tag="span"
          active-class="settings-nav__list-item--active"
          class="settings-nav__list-item">Change Email</router-link>
        <router-link
          :to="{ name: 'PhoneSettings' }"
          tag="span"
          active-class="settings-nav__list-item--active"
          class="settings-nav__list-item">Change Phone</router-link>
        <router-link
          :to="{ name: 'PasswordSettings' }"
          tag="span"
          active-class="settings-nav__list-item--active"
          class="settings-nav__list-item">Change Password</router-link>
        <router-link
          :to="{ name: 'UserNotificationSettings' }"
          tag="span"
          active-class="settings-nav__list-item--active"
          class="settings-nav__list-item">Notifications</router-link>
      </div>
    </aside>
  </div>
</template>

<script>
import SettingsNavMixin from '@/mixins/SettingsNav';

export default {
  name: 'SettingsNav',
  mixins: [SettingsNavMixin],
};
</script>
